import React from 'react';

/**
 * AnimatedLogo — Custodian AI "Friendly Bot" mark (beige theme).
 * Drop-in replacement for the old purple-ring logo. Same export,
 * same 40x40 footprint, so no other component needs to change.
 *
 * Colours: terracotta squircle (#C0492A), white robot head,
 * olive eyes (#5E6B39) that blink, antenna with a pulsing tip.
 */
const AnimatedLogo = () => {
  return (
    <div className="animated-logo" aria-label="Custodian AI">
      <svg width="40" height="40" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* squircle */}
        <rect x="2" y="2" width="96" height="96" rx="26" fill="#C0492A" />
        {/* antenna */}
        <line x1="50" y1="20" x2="50" y2="31" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" />
        <circle className="cai-antenna-tip" cx="50" cy="15" r="5.5" fill="#1A1A18" />
        {/* head */}
        <rect x="25" y="31" width="50" height="44" rx="15" fill="#fff" />
        {/* face screen */}
        <rect x="34" y="42" width="32" height="22" rx="9" fill="#1A1A18" />
        {/* eyes */}
        <circle className="cai-eye" cx="44.5" cy="53" r="4" fill="#5E6B39" />
        <circle className="cai-eye" cx="57.5" cy="53" r="4" fill="#5E6B39" />
      </svg>
    </div>
  );
};

export default AnimatedLogo;

/*
  Add these keyframes to theme-beige.css (or App.css) for the
  blink + antenna pulse. Pure CSS, no JS timers needed:

  .cai-eye      { transform-origin: center; animation: cai-blink 4s ease-in-out infinite; }
  .cai-antenna-tip { animation: cai-pulse 2s ease-in-out infinite; transform-origin: center; }
  @keyframes cai-blink { 0%,92%,100% { transform: scaleY(1); } 96% { transform: scaleY(0.1); } }
  @keyframes cai-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.55; } }
*/
